import { Component, OnInit, Inject, ViewChild, SimpleChanges, HostListener } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormControl, FormGroupDirective, NgForm } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import * as sha256 from 'sha256';
import { ErrorStateMatcher } from '@angular/material/core';
import { EncryptDecryptService } from '../services/encrypt-decrypt.service';
import { VariablesGlobales } from '../services/globals';
import { User } from '../models/user';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import swal from 'sweetalert2';
import { DialogOverviewProbDialog } from '../footer/footer.component';
import { AuthService } from '../services/auth.service';

declare var $: any;

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-lost-password',
  templateUrl: './lost-password.component.html',
  styleUrls: ['./lost-password.component.css']
})
export class LostPasswordComponent implements OnInit {

  isFieldValid(form: FormGroup, field: string) {
    return !form.get(field).valid && form.get(field).touched;
  }

  displayFieldCss(form: FormGroup, field: string) {
    return {
      'has-error': this.isFieldValid(form, field),
      'has-feedback': this.isFieldValid(form, field)
    };
  }

  public _mail: string;
  public _code: string;
  public _pass: string;
  public _passConfirm: string;
  public _key: string;
  public _error: string;

  matcher = new MyErrorStateMatcher();

  public controlForm: FormGroup;

  public indexTab = 0;

  stepIsValid(): boolean {
    if (this.indexTab === 0)
      return this.controlForm.get('email').valid;
    else if (this.indexTab === 1)
      return this.controlForm.get('code').valid;
    return false;
  }

  constructor(public auth: AuthService, public dialog: MatDialog, public param: VariablesGlobales, private encdec: EncryptDecryptService,private formBuilder: FormBuilder, private _formBuilder: FormBuilder, private http: HttpClient, @Inject('BASE_URL') private baseUrl: string, private route: ActivatedRoute, private router: Router) {
    this.controlForm = new FormGroup({
      email: new FormControl(this._mail, [
        Validators.required,
        Validators.pattern('(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))')
      ]),
      code: new FormControl(this._code, [
        Validators.required,
        Validators.minLength(6),
        Validators.maxLength(6)
      ])
    });
  }

  changeTab(index: number) {
    if (index === 0) {
      (document.querySelector('#account') as HTMLElement).style.display = 'none';
      (document.querySelector('#about') as HTMLElement).style.display = 'block';
    } else if (index === 1) {
      (document.querySelector('#about') as HTMLElement).style.display = 'none';
      (document.querySelector('#account') as HTMLElement).style.display = 'block';
    } else if (index === 2) {
      (document.querySelector('#about') as HTMLElement).style.display = 'none';
      (document.querySelector('#account') as HTMLElement).style.display = 'none';
    } else {
      (document.querySelector('#account') as HTMLElement).style.display = 'none';
      (document.querySelector('#about') as HTMLElement).style.display = 'block';
    }
    this.changeIndex(index);
  }

  changeIndex(index) {
    this.indexTab = index;

    let $total = document.querySelectorAll('.wizard-navigation li').length;
    let $current = index + 1;
    (document.querySelector('.main-panel') as HTMLElement).scrollTop = 0;
    const $wizard = document.querySelector('.card-wizard');

    // If it's the last tab then hide the last button and show the finish instead
    if ($current >= $total) {
      $($wizard).find('.btn-next').hide();
      $($wizard).find('.btn-finish').show();
    } else {
      $($wizard).find('.btn-next').show();
      $($wizard).find('.btn-finish').hide();
    }

    const button_text = document.querySelector('.wizard-navigation li:nth-child(' + $current + ') a').firstChild.textContent;

    setTimeout(function () {
      document.querySelector('.moving-tab').innerHTML = button_text;
    }, 150);

    $total = $wizard.querySelectorAll('.nav li').length;
    let $li_width = 100 / $total;

    let total_steps = $wizard.querySelectorAll('.nav li').length;
    let move_distance = $wizard.clientWidth / total_steps;
    let index_temp = index;
    let vertical_level = 0;

    let mobile_device = $(document).width() < 600 && $total > 3;

    if (mobile_device) {
      move_distance = $wizard.clientWidth / 2;
      index_temp = index % 2;
      $li_width = 50;
    }

    $wizard.querySelectorAll('.nav li').forEach(x => (x as HTMLElement).style.width = $li_width + '%');

    let step_width = move_distance;
    move_distance = move_distance * index_temp;

    $current = index + 1;

    if ($current == 1 || (mobile_device == true && (index % 2 == 0))) {
      move_distance -= 8;
    } else if ($current == total_steps || (mobile_device == true && (index % 2 == 1))) {
      move_distance += 8;
    }

    if (mobile_device) {
      let x: any = index / 2;
      vertical_level = parseInt(x);
      vertical_level = vertical_level * 38;
    }

    ($wizard.querySelector('.moving-tab') as HTMLElement).style.width = step_width + 'px';
    ($wizard.querySelector('.moving-tab') as HTMLElement).style.transform = 'translate3d(' + move_distance + 'px, ' + vertical_level + 'px, 0)';
    ($wizard.querySelector('.moving-tab') as HTMLElement).style.transition = 'all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1)';
  }

  ngOnChanges(changes: SimpleChanges) {
    const input = $(this);

    if (input[0].files && input[0].files[0]) {
      const reader: any = new FileReader();

      reader.onload = function (e: any) {
        $('#wizardPicturePreview').attr('src', e.target.result).fadeIn('slow');
      };
      reader.readAsDataURL(input[0].files[0]);
    }
  }

  ngAfterViewInit() {
    let total = document.querySelectorAll('.wizard-navigation li').length;
    let wizard = document.querySelector('.card-wizard');

    let first_li = document.querySelector('.wizard-navigation li').firstChild.textContent;
    let moving_div = '<div class="moving-tab" id="moving-tab">' + first_li + '</div>';
    document.querySelector('.card-wizard .wizard-navigation').insertAdjacentHTML('beforeend', moving_div);

    total = wizard.querySelectorAll('.nav li').length;
    let li_width = 100 / total;

    let total_steps = wizard.querySelectorAll('.nav li').length;
    let move_distance = wizard.clientWidth / total_steps;
    let index_temp = 0;
    let vertical_level = 0;

    let mobile_device = window.innerWidth < 600 && total > 3;

    if (mobile_device) {
      move_distance = wizard.clientWidth / 2;
      index_temp = 0 % 2;
      li_width = 50;
    }

    wizard.querySelectorAll('.nav li').forEach(x => (x as HTMLElement).style.width = li_width + '%');

    let step_width = move_distance;
    move_distance = move_distance * index_temp;

    let $current = 0 + 1;

    if ($current == 1 || (mobile_device == true && (0 % 2 == 0))) {
      move_distance -= 8;
    } else if ($current == total_steps || (mobile_device == true && (0 % 2 == 1))) {
      move_distance += 8;
    }

    if (mobile_device) {
      let x: any = 0 / 2;
      vertical_level = parseInt(x);
      vertical_level = vertical_level * 38;
    }

    (wizard.querySelector('.moving-tab') as HTMLElement).style.width = step_width + 'px';
    $('.moving-tab').css({
      'transform': 'translate3d(' + move_distance + 'px, ' + vertical_level + 'px, 0)',
      'transition': 'all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1)'

    });
    $('.moving-tab').css('transition', 'transform 0s');
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    const e = document.querySelector("#moving-tab");
    document.querySelector('.card-wizard .wizard-navigation').removeChild(e);
    this.ngAfterViewInit();
  }

  ngOnInit(): void {
  }

  onSubmit(index: number): void {
    if (this.indexTab === 0)
      this.sendMail(index);
    else if (this.indexTab === 1)
      this.getCandidate(index);
  }

  sendMail(index: number): void {
    this.http.get('https://api.sitederecrutement.com/Home/SendCode?apikey=' + localStorage.getItem('apikey') + '&email=' + this.controlForm.get('email').value, { responseType: "text" }).subscribe(result => {
      if (result.includes('{Error :')) {
        let json = JSON.parse(result);
      }
      else {
        const obj = JSON.parse(this.encdec.getDecrypt( result));
        this._key = JSON.parse(obj).result;
        if (!this._key) {
          this._error = 'Echec d\'envoi du mail : les données saisies n\'existent pas.<br/><br/>Si vous n\'avez pas commis d\'erreur et si vous êtes sûr(e) de vous être inscrit(e), contacter le service technique en cliquant ';
        }
        else {
          this.changeTab(index);
          this._error = '';
        }
      }
    }, error => console.error(error));
  }

  getCandidate(index: number): void {
    this.http.get('https://api.sitederecrutement.com/Home/GetCandidate?apikey=' + localStorage.getItem('apikey') + '&login=' + this._key + '&pass=' + this.controlForm.get('code').value, { responseType: "text" }).subscribe(result => {
      if (result.includes('{Error :')) {
        let json = JSON.parse(result);
      }
      else {
        let data = this.encdec.getDecrypt( result);
        let obj = JSON.parse(data);
        if (obj) {
          const user: User = {
            idcandidat: obj.idcandidat,
            can_echec_connexion: obj.can_echec_connexion,
            can_echec_connexion_date: obj.can_echec_connexion_date,
            can_echec_connexion_heure: obj.can_echec_connexion_heure,
            can_passe_date: obj.can_passe_date,
            candidat_api: obj.can_session_api,
            can_passe_modif: obj.can_passe_modif,
            photo: obj.photo,
            consentement: obj.consentement,
            nom: obj.can_nom,
            prenom: obj.can_prenom,
            mail: obj.can_mail,
            portable: obj.can_tel_mob
          }
          localStorage.setItem('currentUser', JSON.stringify(user));
          this.param.editPasswordForced = true;
          this.param.editDossier = true;
          this.router.navigate(['profil']);
        } else {
          this._error = 'Code invalide !';
        }

      }
    }, error => console.error(error));
  }

  openDialogSend(): void {
    event.preventDefault();
    const dialogRef = this.dialog.open(DialogOverviewProbDialog, {
      width: '80%',
      data: {
        page: this.router.url,
        corps: '',
      },
      panelClass: 'custom-modalbox'
    });

    dialogRef.afterClosed().subscribe(resulta => {
      if (resulta) {
        const userInfo: Mail = {
          from: 'vich@rhprofiler.info',
          to: resulta.email,
          corps: resulta.corps + '\r\n\r\n\r\nUrl : ' + this.router.url + '\r\nEmail : ' + resulta.email + '\r\nTel : ' + resulta.sms,
          subject: resulta.obj,
          sms: resulta.sms
        }
        let data = this.encdec.getEncrypt( JSON.stringify(userInfo));
        const formData = new FormData();
        formData.append('datas', data);
        this.http.post('https://api.sitederecrutement.com/Home/SendMailProb?apikey=' + localStorage.getItem('apikey'), formData, { responseType: "text" }).subscribe(
          (result) => {
            swal.fire({
              title: "Votre rapport est bien envoyé.",
              buttonsStyling: false,
              customClass: {
                confirmButton: "btn btn-rose",
              },
              icon: "success",
              iconColor: 'd '
            });
          }
        )
      }
    });
  }
}

interface Mail {
  from: string;
  to: string;
  subject: string;
  corps: string;
  sms: string;
}
